<nz-row nzJustify="end">
  <nz-col *ngIf="!($sortable | async)" nzFlex>
    <button nz-button nzType="primary" (click)="reorder()">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      Reihenfolge übernehmen
    </button>
  </nz-col>
</nz-row>
<nz-row>
  <nz-col nzSpan="24">
    <nz-list *ngIf="projektArts.result$ | async" nzSize="large" [nzLoading]="$loading | async" cdkDropList (cdkDropListDropped)="reorder($event)">
      <nz-list-item *ngFor="let projektArt of (projektArts.result$ | async).projektArts" (click)="select.emit(projektArt)" cdkDrag class="drag-container">
        <nz-list-item-meta [nzDescription]="ListDescription">
          <ng-template #ListDescription>
            <!--- << description    -->
            <!---    description >> -->
          </ng-template>
          <nz-list-item-meta-title>
            <a>
              <!--- << content    -->
              <strong>{{ projektArt.initialen }}</strong> | {{ projektArt.name }}
              <!---    content >> -->
            </a>
          </nz-list-item-meta-title>
        </nz-list-item-meta>
        <ul nz-list-item-actions>
          <nz-list-item-action>
            <a><i nz-icon nzType="edit" nzTheme="outline"></i></a>
            <a style="margin-left: 16px" *ngIf="$sortable | async" cdkDragHandle><i nz-icon nzType="menu" nzTheme="outline"></i></a>
          </nz-list-item-action>
        </ul>
      </nz-list-item>
    </nz-list>
  </nz-col>
</nz-row>
